import { connect }              from 'react-redux';
import bail                     from '../util/bail';
import PrimaryButton            from './primary_button';
import React                    from 'react';
import ResourceUnavailableImage from '../assets/images/resource-unavailable.svg';


// https://reactjs.org/docs/error-boundaries.html
export default class ErrorBoundary extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary:', error, info);
    this.setState({ error });
  }

  render() {
    if (this.state.error)
      return <ErrorPageWithBail/>;
    else
      return this.props.children;
  }
}


const ErrorPageWithBail = connect(null,
  () => ({
    restart: bail
  })
)(ErrorPage);


// If the component fails to render, user will see this error page instead
//
// This page has one action, and clicking on it:
// - Clear Redux store
// - Restart app with the root page
function ErrorPage({ restart }) {
  return (
    <div className="page-content">
      <div className="startup-error">
        <div className="startup-error__logo"/>
        <ResourceUnavailableImage className="startup-error__image"/>
        <h1>We have an error</h1>
        <div className="startup-error__cta">
          <p>We will look into the issue as soon as possible.</p>
          <p>In the meantime, you can try restarting the app.</p>
          <PrimaryButton label="Restart" onClick={restart}/>
        </div>
      </div>
    </div>
  );
}
